import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { ClientValidationResultsTrigger } from './ClientValidationResults'

export { ClientValidationResultsTrigger }

export default Loadable(() => import('./ClientValidationResults'))
